var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"my-5"},[_c('h1',{staticClass:"text-center"},[_vm._v("Page Not Found")]),_c('p',{staticClass:"text-center"},[_vm._v("we couldn't find the page you are looking for")])])}
var staticRenderFns = []

export { render, staticRenderFns }